import { ContentModel, contentModelInitial } from './ContentModel';

export interface ContentBatchModel {
    content: ContentModel,
    categoriesId: number[]
}

export const contentBatchModelInitial: ContentBatchModel = {
    content: contentModelInitial,
    categoriesId: []
};